module.exports = __webpack_public_path__ + "media/F8.0d2bd201.wav";